import React, { useCallback } from 'react'
import styled from 'styled-components'

const DotButton = styled.button<{ isActive: boolean }>`
  width: 60px;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-right: 10px;
  position: relative;

  &:before {
    content: '';
    border-bottom: 1px solid white;
    opacity: ${({ isActive }) => (isActive ? 1 : 0.3)};
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform: translateY(-50%);
  }
`

const Container = styled.div`
  display: block;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 20px;
`

interface Props {
  slideCount: number
  currentSlide: number
  gotoSlide: (slideIndex: number) => void
}

const HeroSliderPagination: React.FC<Props> = ({
  slideCount,
  currentSlide,
  gotoSlide,
}) => {
  const slideIndices = [...Array(slideCount)].map((_, i) => i)

  const handleClick = useCallback(
    (slideIndex: number) => () => {
      gotoSlide(slideIndex)
    },
    [gotoSlide],
  )

  return (
    <Container>
      {slideIndices.map(slide => {
        const isActive = slide === currentSlide
        return (
          <DotButton
            type="button"
            key={slide}
            isActive={isActive}
            onClick={handleClick(slide)}
          />
        )
      })}
    </Container>
  )
}

export default HeroSliderPagination
